import React, { useEffect, useState } from "react";
import { useStoreState } from "pullstate";

import { PlayerStore } from "@/store/PlayerStore";
import useRequest from "@/helpers/useRequest";
import { apiPath } from "@/helpers/apiPath";
import { CurrentScheduleInterface } from "@/helpers/pageHelpers/Common/interface";
import { getScheduleTiming } from "@/helpers/getScheduleTiming";
import MinimalProgressBar from "@/components/Players/MinimalProgressBar";
import Typography from "@/components/Typography";
import { getHourMinuteFromDate } from "@/helpers/getHourMinuteFromDate";

import styles from "./ScheduleTimeline.module.scss";

export const ScheduleTimeline: React.FC = () => {
  const { isSchedulePlaying, scheduleStart, scheduleEnd, scheduleTitle } =
    useStoreState(PlayerStore, (store) => store);
  const [currentTime, setCurrentTime] = useState<number>();
  const [duration, setDuration] = useState<number>();
  const { data } = useRequest(
    apiPath.CURRENTLY_PLAYING_SCHEDULE
  ) as CurrentScheduleInterface;
  const isDataAvailable = !!data;
  const isVisible = scheduleStart || scheduleEnd;

  const setTimes = () => {
    const { currentTime, duration } = getScheduleTiming(
      scheduleStart,
      scheduleEnd
    );

    isDataAvailable
      ? PlayerStore.update((store) => {
          store.isScheduleAvailable = true;
        })
      : PlayerStore.update((store) => {
          store.isScheduleAvailable = false;
        });

    setCurrentTime(currentTime);
    setDuration(duration);
  };

  useEffect(() => {
    if (isDataAvailable) {
      // First Check
      setTimes();

      // Checks with 5s interval
      const radioInterval = setInterval(() => {
        setTimes();
      }, 5000);
      return () => clearInterval(radioInterval);
    }
  }, [data]);

  return (
    isVisible && (
      <div className={styles.wrapper}>
        <Typography variant="h4" component="p">
          {scheduleTitle}
        </Typography>
        <Typography variant="medium" component="p">
          {getHourMinuteFromDate(scheduleStart)} -{" "}
          {getHourMinuteFromDate(scheduleEnd)}
        </Typography>

        <MinimalProgressBar
          duration={duration}
          currentTime={currentTime}
          show={isSchedulePlaying}
          className={styles.timeline}
          progressClassName={styles.progress}
        />
      </div>
    )
  );
};

export default ScheduleTimeline;
